import { createSlice } from '@reduxjs/toolkit';

/**
 * UI state — sidebar açık/kapalı, toast mesajları, modal state'leri.
 * iframe içinde hover state'i ve modal positioning için kullanışlı.
 */
const initialState = {
  sidebarOpen: true,
  mobileSidebarOpen: false,
  toasts: [], // { id, kind: 'success'|'error'|'info'|'warn', message, ttl }
  modal: null, // { kind, payload }
};

let toastSeq = 0;

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebar(state, action) {
      state.sidebarOpen = action.payload;
    },
    toggleMobileSidebar(state) {
      state.mobileSidebarOpen = !state.mobileSidebarOpen;
    },
    closeMobileSidebar(state) {
      state.mobileSidebarOpen = false;
    },
    pushToast: {
      prepare(payload) {
        toastSeq += 1;
        const kind = typeof payload === 'string' ? 'info' : payload.kind || 'info';
        const message = typeof payload === 'string' ? payload : payload.message;
        const ttl = typeof payload === 'object' && payload.ttl ? payload.ttl : 4000;
        return { payload: { id: toastSeq, kind, message, ttl } };
      },
      reducer(state, action) {
        state.toasts.push(action.payload);
      },
    },
    dismissToast(state, action) {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    openModal(state, action) {
      state.modal = action.payload;
    },
    closeModal(state) {
      state.modal = null;
    },
  },
});

export const {
  toggleSidebar,
  setSidebar,
  toggleMobileSidebar,
  closeMobileSidebar,
  pushToast,
  dismissToast,
  openModal,
  closeModal,
} = uiSlice.actions;
export default uiSlice.reducer;
